import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { clientConfigFn } from "clientConfig";
const FooterText = () => {
    const { footerText } = clientConfigFn();
    return (_jsx("div", { children: footerText && (_jsx(Typography, { sx: { whiteSpace: "pre-line" }, children: footerText })) }));
};
export { FooterText };
